import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import es from './locales/es.json';
import ptBR from './locales/pt-BR.json';

const DETECTION_ORDER = ['localStorage', 'navigator'] as const;
const LANG_STORAGE_KEY = 'kairos.lang';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      'pt-BR': { translation: ptBR },
    },
    // Default language is Spanish (Lopettia targets PR + LATAM + Mainland US).
    // English and pt-BR are first-class — users override via the language
    // picker, persisted in localStorage. fallbackLng only kicks in when a
    // key is missing from the active locale.
    fallbackLng: 'es',
    supportedLngs: ['es', 'en', 'pt-BR'],
    interpolation: { escapeValue: false },
    detection: {
      order: [...DETECTION_ORDER],
      caches: ['localStorage'],
      lookupLocalStorage: LANG_STORAGE_KEY,
    },
  });

export default i18n;
